import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { Form, Grid } from "semantic-ui-react";
import QuestionSet from "../components/QuestionSet";
import { BasicLoadingState } from "../State";
import { store, handleSubmit } from "../store";

const PlanQuestionnaire: React.FunctionComponent = () => {
    const [state, setState] = useState<BasicLoadingState>({ isLoading: false });

  const globalState = useContext(store);
  const { dispatch } = globalState;

    return (
        !(globalState.state.appState.user &&
            globalState.state.appState.user.profile.role_extended.includes("BureauPortal:plan_carrier")) &&
        <Redirect to={"/"} /> ||
        <Grid centered className="QuestionSetContainer">
            <Form size={"small"} method="post" action="/Index" encType="multipart/form-data">
                {
                    <QuestionSet isLoading={state.isLoading} icon={state.icon}
                        onSubmit={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleSubmit({ state, setState },
                            globalState.state, e, "ANC")}
                        questionAnswers={globalState.state.answerState!} />
                }
            </Form>
        </Grid>
  );
};

export default PlanQuestionnaire;
